var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationPinRotate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7003 4.99734C12.5291 4.99734 13.201 4.32549 13.201 3.49672C13.201 2.66795 12.5291 1.99609 11.7003 1.99609C10.8716 1.99609 10.1997 2.66795 10.1997 3.49672C10.1997 4.32549 10.8716 4.99734 11.7003 4.99734Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9997 16.0017H12.6004C13.2007 16.0017 13.6008 15.6015 13.6008 15.0013V12.2501L14.6012 11.0496C14.7013 10.8495 14.8013 10.6495 14.8013 10.4494V8.24846C14.8013 7.64821 14.4012 7.24805 13.8009 7.24805H9.79924C9.19899 7.24805 8.79883 7.64821 8.79883 8.24846V10.4494C8.79883 10.6495 8.89887 10.8495 8.99891 11.0496L9.99933 12.2501V15.0013C9.99933 15.6015 10.3995 16.0017 10.9997 16.0017Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7998 21.004L12.0003 19.8035L10.7998 18.603",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0027 13.7051C19.8394 14.3443 21.0039 15.2677 21.0039 16.3022C21.0039 17.7748 18.6629 19.0333 15.3516 19.5505",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99783 13.7051C4.16107 14.3443 2.99658 15.2677 2.99658 16.3022C2.99658 18.236 7.02726 19.8036 12.0003 19.8036",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinRotate);
export default __webpack_public_path__ + "static/media/location-pin-rotate.96524597.svg";
export { ForwardRef as ReactComponent };